
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcGaugeTrend as ObcGaugeTrendElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/gauge-trend/gauge-trend.js';
 
 
 

 
 export const ObcGaugeTrend = createComponent({
   react: React,
   tagName: 'obc-gauge-trend',
   elementClass: ObcGaugeTrendElement,
   events: {
     
   }
  });
 
 